;(() => {
  const load = async (container) => {
    if (container.dataset.lrcMounted === 'true') return
    container.dataset.lrcMounted = 'true'
    const configNode = container.querySelector('[data-lrc-app-config]')
    const target = container.querySelector('[data-lrc-app-target]')
    const fail = () => {
      if (target) {
        target.innerHTML =
          '<p class="lrc-copy">Registration is temporarily unavailable. Please refresh or contact support.</p>'
      }
    }

    try {
      const config = JSON.parse(configNode?.textContent || '{}')
      if (!target || !config.targetId) return fail()

      if (!document.querySelector('link[data-lrc-quick-asset="style"]')) {
        const stylesheet = document.createElement('link')
        stylesheet.rel = 'stylesheet'
        stylesheet.href = config.stylesheetUrl
        stylesheet.dataset.lrcQuickAsset = 'style'
        document.head.append(stylesheet)
      }

      if (!window.LRCQuick) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script')
          script.src = config.assetUrl
          script.type = 'module'
          script.dataset.lrcQuickAsset = 'script'
          script.addEventListener('load', resolve, { once: true })
          script.addEventListener('error', reject, { once: true })
          document.head.append(script)
        })
      }

      await window.LRCQuick.mount(config)
    } catch {
      fail()
    }
  }

  const start = () => {
    document.querySelectorAll('[data-lrc-app-mount]').forEach((node) => void load(node))
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true })
  } else {
    start()
  }
  document.addEventListener('shopify:section:load', start)
})()
